/** Klien API super admin (platform). */

import { api } from "./client";

export interface PlatformDashboard {
  totalTenant: number;
  activeTenant: number;
  totalBooking: number;
  totalPatient: number;
  totalTherapist: number;
}

export interface PlatformTenant {
  id: string;
  name: string;
  slug: string;
  status: "ACTIVE" | "SUSPENDED";
  phone: string | null;
  email: string | null;
  address: string | null;
  description: string | null;
  createdAt: string;
  _count: { bookings: number; therapists: number; patientProfiles: number };
}

export function fetchPlatformDashboard(): Promise<PlatformDashboard> {
  return api.get<{ dashboard: PlatformDashboard }>("/platform/dashboard").then((r) => r.dashboard);
}

export function fetchPlatformTenants(): Promise<PlatformTenant[]> {
  return api.get<{ tenants: PlatformTenant[] }>("/platform/tenants").then((r) => r.tenants);
}

export function createTenant(body: {
  name: string;
  slug: string;
  phone?: string;
  email?: string;
  address?: string;
  description?: string;
}) {
  return api.post<{ tenant: PlatformTenant }>("/platform/tenants", body).then((r) => r.tenant);
}

export function updateTenant(
  id: string,
  body: Partial<Pick<PlatformTenant, "name" | "status" | "phone" | "email" | "address" | "description">>,
) {
  return api.patch<{ tenant: PlatformTenant }>(`/platform/tenants/${id}`, body).then((r) => r.tenant);
}

export function createTenantAdmin(id: string, body: { fullName: string; email: string; password?: string }) {
  return api
    .post<{ admin: { id: string; email: string; fullName: string }; initialPassword?: string }>(
      `/platform/tenants/${id}/admins`,
      body,
    )
    .then((r) => r);
}
